import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type UiCardSampleDataDb = {
  cardId: string;
  itemId: string;
  row: number;
  content: string;
}
const initial: UiCardSampleDataDb = {
  cardId: '',
  itemId: '',
  row: 0,
  content: ''
};

export type UiCardSampleDataDbHashType = {
  [key in string]: UiCardSampleDataDb;
}

export type UiCardSampleDataAddPayload = {
  id?: string;
} & UiCardSampleDataDb;
export type UiCardSampleDataUpdatePayload = {
  id: string;
} & { [P in keyof UiCardSampleDataDb]?: UiCardSampleDataDb[P] };

export type UiCardSampleDataDbState = {
  uiCardSampleDatas: UiCardSampleDataDbHashType;
}

export const generateUiCardSampleDataId = (): string => generateId('ucsd');
let initialState: UiCardSampleDataDbState = { uiCardSampleDatas: {} };
const key = 'uiCardSampleDatas';

const uiCardSampleDataDbSlice = createSlice({
  name: 'uiCardSampleDataDb',
  initialState,
  reducers: {
    initializeUiCardSampleDatas(state: UiCardSampleDataDbState) {
      state.uiCardSampleDatas = {};
    },
    addUiCardSampleData(state: UiCardSampleDataDbState, action: PayloadAction<UiCardSampleDataAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateUiCardSampleDataId();
      state.uiCardSampleDatas[id] = obj;
      saveData(key, id, obj);
    },
    updateUiCardSampleData(state: UiCardSampleDataDbState, action: PayloadAction<UiCardSampleDataUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.uiCardSampleDatas[id] === undefined) {
        console.log(`*** UiCardSampleData not found: ${id}`);
      } else {
        const newData = { ...state.uiCardSampleDatas[id], ...obj };
        state.uiCardSampleDatas[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteUiCardSampleData(state: UiCardSampleDataDbState, action: PayloadAction<UiCardSampleDataUpdatePayload>) {
      const id = action.payload.id;
      delete state.uiCardSampleDatas[id];
      deleteData(key, id);
    },
    saveUiCardSampleDatas(state: UiCardSampleDataDbState) {
      saveAllData(key, state.uiCardSampleDatas);
    },
    signUpUiCardSampleDatas(state: UiCardSampleDataDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.uiCardSampleDatas, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: UiCardSampleDataDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.uiCardSampleDatas = updatedValues;
      if (changed) saveAllData(key, state.uiCardSampleDatas);
    })
  }
})

export const { initializeUiCardSampleDatas, addUiCardSampleData, updateUiCardSampleData, deleteUiCardSampleData, saveUiCardSampleDatas, signUpUiCardSampleDatas } = uiCardSampleDataDbSlice.actions;
export default uiCardSampleDataDbSlice.reducer;
